import constants, { ACCESS_TOKEN, default_size_mcp, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type' : 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function createWorkflow(payloadData) {
    return axiosClient({
        url: constants.api.workflow.create_workflow,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: payloadData
    })
}

function publishWorkflow(payloadData) {
    return axiosClient({
        url: constants.api.workflow.publish_workflow,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: payloadData
    })
}

function executeWorkflow(payloadData) {
    return axiosClient({
        url: constants.api.workflow.execute_workflow,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: payloadData
    })
}

function generateWorkflow(payloadData) {
    return axiosClient({
        url: constants.api.workflow.generate_workflow,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: payloadData
    })
}

function getMCPTools(page, data) {
    return axiosClient({
        url: constants.api.workflow.getMcp + "?page=" + page + "&size=" + default_size_mcp,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data ? data : {}
    })
}

function getAuthProvider(provider, page = 0, size = 10) {
    return axiosClient({
        url: constants.api.oauth.getAuthProvider + provider + "?page=" + page + "&size=" + size,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    })
}

function getWorkflowHistory(projectId, page = 0, size = 10) {
    return axiosClient({
        url: constants.api.workflow.getWorkflowHistory +"?projectId=" + projectId + "&page=" + page + "&size=" + size,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: {}
    })
}

function getWorkflowExecution(executionId, agentId, page = 0, size = 10) {
    return axiosClient({
        url: constants.api.workflow.getWorkflowExecution + executionId + "/agents/" + agentId + "/execution-messages?page=" + page + "&size=" + size,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
    })
}

function getOrchestratorPublishedHistory(orchestratorId, page = 0, size = 10) {
    return axiosClient({
        url: constants.api.workflow.get_orchestrator + "/" + orchestratorId + "?page=" + page + "&size=" + size,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
    })
}

function restoreOrchestrator(orchestratorId = null) {
    return axiosClient({
        url: constants.api.workflow.restore_orchestrator + "/" + orchestratorId,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data:{}
    })
}

const WorkflowService = {
    createWorkflow,
    publishWorkflow,
    executeWorkflow,
    generateWorkflow,
    getMCPTools,
    getAuthProvider,
    getWorkflowHistory,
    getWorkflowExecution,
    getOrchestratorPublishedHistory,
    restoreOrchestrator
}
export default WorkflowService;